import { Box, Typography } from "@mui/material";
import React from "react";
import {
  border25,
  borderTextbox,
  greyColor6,
  greyShade07,
  whiteColor,
} from "../../configs/styles/muiThemes";

function ImagePreview({
  label,
  infoText,
  labelSize,
  styles,
  hideBorder,
  hideLabel,
  value,
}) {
  return (
    <Box sx={inputBox(hideBorder)}>
      {!hideLabel ? (
        <Typography
          variant="h3"
          fontSize={{ xs: 12, md: labelSize || 12.5 }}
          color={greyColor6}
          fontWeight={400}
          mb={{
            xs: labelSize ? "0px !important" : "4px !important",
            md: labelSize ? "0px !important" : "5px !important",
          }}
          sx={{ ...styles }}
        >
          {label}{" "}
          <span style={{ fontSize: "12.5px", color: greyShade07 }}>
            {infoText}
          </span>
        </Typography>
      ) : (
        <Box sx={{ height: "22px" }} />
      )}
      {value ? (
        <Box
          component="img"
          src={value}
          width="35px"
          height="35px"
          sx={{ borderRadius: "7px", border: border25 }}
        />
      ) : (
        "-"
      )}
    </Box>
  );
}

export default ImagePreview;

const inputBox = (hideBorder) => ({
  pb: { md: 0, xs: 0 },
  borderBottom: hideBorder ? "none" : borderTextbox,
  backgroundColor: whiteColor,
});
